/**
 * @module root/components/policies
 */
import * as STATES from './pnp.states';
import { PNP_ACCRED_MODULE } from './pnp-accred/pnp-accred.module';
import { PNP_SETTINGS_MODULE } from './pnp-settings/pnp-settings.module';
import { PNP_DOCUMENTS_MODULE } from './pnp-docs/pnp-docs.module';

export const POLICIES_MODULE = angular.module(
    'migration.pnp',
    [
        PNP_ACCRED_MODULE.name,
        PNP_SETTINGS_MODULE.name,
        PNP_DOCUMENTS_MODULE.name
    ]
).config(['$uiRouterProvider', ({ stateRegistry }) => {
    Object.values(STATES).map(state => stateRegistry.register(state))
}]).component({
    // TODO register components
}).run(['$templateCache', ({ put }) => {
}]);
